export const enum UserCoordinatesSource {
  // NOTE: None means, that no coordinates were successfully loaded
  None = 'none',
  // NOTE: GeolocationApi means, that coordinates were loaded from browser geolocation API, better precision
  GeolocationApi = 'geolocationApi',
  // NOTE: IpApi means, that coordinates were loaded using external sources, lower precision
  IpApi = 'ipApi',
}
